import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-wrap p-justify-between" }
const _hoisted_2 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_3 = { class: "p-input-icon-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)

import CreateEmployee from "./CreateEmployee.vue";
import UpdateEmployee from "./UpdateEmployee.vue";
import { useRemoveEmployee } from "./hooks/useRemoveEmployee";
import { useEmployees } from "./hooks/useEmployees";
import { useDownload } from "@/hooks/file/useDownload";
import FunctionMultiselect from "../function/FunctionMultiselect.vue";
import SectorMultiselect from "../sector/SectorMultiselect.vue";
import { useFunctions } from "../function/hooks/useFunctions";
import { useSectors } from "../sector/hooks/useSectors";


export default /*#__PURE__*/_defineComponent({
  __name: 'Employees',
  setup(__props) {

const { sectors } = useSectors();
const { functions } = useFunctions();
const { loading, employees, filter, clearFilter } = useEmployees();
const { removeLoading, handleRemove } = useRemoveEmployee();
const { loading: downloadLoading, downloadFile } = useDownload();

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(UpdateEmployee, null, {
    default: _withCtx(({ openUpdate }) => [
      _createVNode(_component_DataTable, {
        value: _unref(employees),
        responsiveLayout: "scroll",
        dataKey: "id",
        loading: _unref(loading) || _unref(downloadLoading),
        rowHover: false,
        filters: _unref(filter),
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_isRef(filter) ? (filter).value = $event : null)),
        filterDisplay: "menu",
        globalFilterFields: [
        'firstName',
        'lastName',
        'function.name',
        'sector.name',
      ]
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CreateEmployee),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_InputText, {
                  placeholder: _ctx.$t('search'),
                  modelValue: _unref(filter)['global'].value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter)['global'].value) = $event))
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-filter-slash",
                label: _ctx.$t('clear'),
                class: "p-button-outlined p-ml-1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(clearFilter)()))
              }, null, 8, ["label"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "lastName",
            header: _ctx.$t('hr_last_name'),
            "show-add-button": false,
            showFilterOperator: false,
            filterField: "lastName",
            sortable: ""
          }, {
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: 
              _ctx.$t('filterBy', { field: _ctx.$t('hr_last_name').toLowerCase() })
            
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "firstName",
            header: _ctx.$t('hr_fistname'),
            "show-add-button": false,
            showFilterOperator: false,
            filterField: "firstName",
            sortable: ""
          }, {
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: 
              _ctx.$t('filterBy', { field: _ctx.$t('hr_fistname').toLowerCase() })
            
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            showFilterMatchModes: false,
            "show-add-button": false,
            showFilterOperator: false,
            field: "sector.name",
            filterField: "sector.id",
            header: _ctx.$t('sector'),
            sortable: "",
            sortField: "sector.id"
          }, {
            filter: _withCtx(({ filterModel }) => [
              _createVNode(SectorMultiselect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                options: _unref(sectors),
                style: {"max-width":"220px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-mr-1 p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            showFilterMatchModes: false,
            "show-add-button": false,
            showFilterOperator: false,
            field: "function.name",
            filterField: "function.id",
            header: _ctx.$t('function'),
            sortable: "",
            sortField: "function.id"
          }, {
            filter: _withCtx(({ filterModel }) => [
              _createVNode(FunctionMultiselect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                options: _unref(functions),
                style: {"max-width":"220px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-mr-1 p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "contacts",
            filterField: "contacts",
            header: _ctx.$t('hr_contacts'),
            sortable: "",
            sortField: "contacts"
          }, {
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: 
              _ctx.$t('filterBy', { field: _ctx.$t('hr_contacts').toLowerCase() })
            
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "cv",
            header: "CV"
          }, {
            body: _withCtx(({ data, field }) => [
              (data[field])
                ? (_openBlock(), _createBlock(_component_Tag, {
                    key: 0,
                    onClick: ($event: any) => (_unref(downloadFile)('employees', data[field])),
                    class: "cursor-pointer",
                    icon: "pi pi-download",
                    value: data[field]
                  }, null, 8, ["onClick", "value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "identity",
            header: "Pièce d'identité"
          }, {
            body: _withCtx(({ data, field }) => [
              (data[field])
                ? (_openBlock(), _createBlock(_component_Tag, {
                    key: 0,
                    onClick: ($event: any) => (_unref(downloadFile)('employees', data[field])),
                    class: "cursor-pointer",
                    icon: "pi pi-download",
                    value: data[field]
                  }, null, 8, ["onClick", "value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "entryDate",
            header: _ctx.$t('hr_entry_date'),
            sortable: true,
            "sort-field": "entryDate",
            "show-add-button": false,
            showFilterOperator: false,
            "filter-field": "entryDate",
            dataType: "date"
          }, {
            body: _withCtx(({ data, field }) => [
              _createTextVNode(_toDisplayString(data[field] && _ctx.$d(data[field])), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_Calendar, {
                manualInput: false,
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                dateFormat: _ctx.$t('format.range'),
                placeholder: _ctx.$t('format.range')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "departureDate",
            header: _ctx.$t('hr_departure_date'),
            sortable: true,
            "sort-field": "departureDate",
            "show-add-button": false,
            showFilterOperator: false,
            "filter-field": "departureDate",
            dataType: "date"
          }, {
            body: _withCtx(({ data, field }) => [
              _createTextVNode(_toDisplayString(data[field] && _ctx.$d(data[field])), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_Calendar, {
                manualInput: false,
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                dateFormat: _ctx.$t('format.range'),
                placeholder: _ctx.$t('format.range')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "id",
            header: "Action"
          }, {
            body: _withCtx(({ data, field }) => [
              _createVNode(_component_Button, {
                icon: "pi pi-pencil",
                onClick: ($event: any) => (openUpdate(data))
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                disabled: _unref(removeLoading),
                onClick: ($event: any) => (_unref(handleRemove)($event, data[field])),
                class: "p-button-danger p-ml-2"
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["value", "loading", "filters"])
    ]),
    _: 1
  }))
}
}

})